import React from "react";
import styled from "styled-components";
import { ArrowPointLeft, palette } from "@conserveit/blocks";

// Style Helpers
function upOrDown({ delta }: { delta: number }) {
  const rotation = delta > 0 ? "90deg" : "-90deg";
  return `transform: rotate(${rotation})`;
}

interface DeltaProps {
  lessIsGood?: boolean;
  lessIsBad?: boolean;
  delta: number;
}
/**
 * If lessIsGood is present, return positive color on positive delta
 * If lessIsBad, do the return negative
 * If zero, or neither flag present, return 'inherit'
 */
function goodOrBad({ lessIsGood, lessIsBad, delta }: DeltaProps): string {
  if (lessIsGood) {
    return delta < 0 ? palette.green5 : palette.red5;
  }

  if (lessIsBad) {
    return delta > 0 ? palette.green5 : palette.red5;
  }

  return "inherit";
}

const Arrow = styled(ArrowPointLeft)`
  width: 16px;
  height: 16px;
`;

const Message = styled.span`
  display: inline-block;
  margin-left: 2px;
  font-size: 14px;
  line-height: 16px;
  color: inherit;
`;

const StyledDelta = styled.div<DeltaProps>`
  display: inline-flex;
  line-height: 0;
  color: ${goodOrBad};

  ${Arrow} {
    fill: ${goodOrBad};
    ${upOrDown};
  }

  ${Message} {
    color: ${goodOrBad};
  }
`;

interface Props {
  children: any;
  [key: string]: any;
}

const Delta: React.FC<Props & DeltaProps> = ({ children, ...props }) => (
  <StyledDelta {...props}>
    <Arrow />
    <Message>{children}</Message>
  </StyledDelta>
);

export default Delta;
